import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import Sidebar from "./Sidebar"; // Import your Sidebar component
import axios from "axios";

const ContactManagement = () => {
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    fetchContactList(currentPage);
  }, [currentPage]);

  const fetchContactList = async (page) => {
    try {
      const token = localStorage.getItem("token"); // Retrieve the token from local storage
      const response = await axios.get(
        `https://admin.yelospace.com/contact-us-list?page=${page - 1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Use the retrieved token for authentication
          },
        }
      );
      //console.log"====================================");
      //console.logresponse);
      //console.log"====================================");
      const { contacts, totalItems, totalPages } =
        response?.data?.response || {};
      //console.log"Fetched Contacts:", contacts); // Log fetched contacts for debugging
      setContactList(contacts);
      setTotalItems(totalItems);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Error fetching contact list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Container style={{ display: "flex", marginTop: "20px" }}>
      <Sidebar />

      <div style={{ flex: "1", marginLeft: "20vw" }}>
        <Typography
          variant="h6"
          style={{
            color: "#F5C000",
            fontWeight: "bold",
            marginBottom: "12px",
            marginTop: "24px",
          }}
        >
          Contact Us Management
        </Typography>
        <Paper
          elevation={0}
          style={{ width: "100%", border: "1px solid #fee9c5" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              borderBottom: "1px solid #F5C000",
            }}
          >
            <Typography variant="body1" component="p">
              Users ({totalItems})
            </Typography>
          </div>

          <TableContainer>
            <Table style={{ border: "1.5px solid #fee9c5" }}>
              <TableHead>
                <TableRow style={{ borderBottom: "1.5px solid #fee9c5" }}>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Email</b>
                  </TableCell>
                  <TableCell>
                    <b>Mobile Number</b>
                  </TableCell>
                  <TableCell>
                    <b>Company Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Query</b>
                  </TableCell>
                  <TableCell>
                    <b>Listing Url</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contactList.map((contact) => (
                  <TableRow
                    key={contact.id}
                    style={{ borderBottom: "1.5px solid #fee9c5" }}
                  >
                    <TableCell>
                      <Checkbox style={{ color: "#F5C000" }} />{" "}
                      {/* Row Checkbox */}
                    </TableCell>
                    <TableCell>{contact.name}</TableCell>
                    <TableCell>{contact.email}</TableCell>
                    <TableCell>{contact.phoneNo}</TableCell>
                    <TableCell>{contact.companyName}</TableCell>
                    <TableCell>{contact.message}</TableCell>
                    <TableCell>
                      <a
                        href={contact.listingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {contact.listingUrl}
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {[...Array(totalPages).keys()].map((pageNumber) => (
            <Button
              key={pageNumber}
              variant="contained"
              style={{
                borderRadius: "20px",
                marginRight: "5px",
                backgroundColor:
                  currentPage === pageNumber + 1 ? "#5F5F61" : "white",
                color: currentPage === pageNumber + 1 ? "white" : "#5F5F61",
              }}
              onClick={() => paginate(pageNumber + 1)}
            >
              {pageNumber + 1}
            </Button>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default ContactManagement;
